var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRealEstateLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6002 35.3198C36.6002 36.8898 35.3202 38.1598 33.7602 38.1598H25.4202C23.8102 38.1598 22.2502 37.5798 21.0302 36.5398L15.7602 32.0498H12.9802V22.5498H21.8402C22.5602 22.5498 23.2802 22.8098 23.8302 23.2798L28.5502 27.2898C29.2302 27.8698 29.5802 28.6898 29.5802 29.5298C29.5802 30.2098 29.3502 30.8798 28.8802 31.4298C28.4402 31.9598 27.8502 32.2898 27.2202 32.4298L26.5302 32.4898H33.7602C34.5502 32.4898 35.2502 32.8098 35.7602 33.3098C36.2802 33.8298 36.6002 34.5398 36.6002 35.3298V35.3198Z",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7902 30.0999L24.7401 31.7598C25.4501 32.3598 26.3602 32.5699 27.2202 32.4099",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9901 22.5498V32.0498H8.88016C8.07016 32.0498 7.41016 31.3898 7.41016 30.5798V24.0298C7.41016 23.2198 8.07016 22.5598 8.88016 22.5598H12.9901V22.5498Z",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9004 29.0894V16.9994C33.9004 16.1494 33.5404 15.3394 32.9004 14.7694L26.6104 9.11937C25.8504 8.43937 24.7004 8.43937 23.9404 9.11937L17.6504 14.7694C17.0204 15.3394 16.6504 16.1494 16.6504 16.9994V19.0894",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2695 17.25H28.2695",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 13.0602V8.49023",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRealEstateLight);
export default __webpack_public_path__ + "static/media/icon_real_estate_light.5f9eef41.svg";
export { ForwardRef as ReactComponent };